const Audience = () => {
    return (
        <section className="bg-light" id="Audience" style={{padding:'100px'}}>
            <div className="container">
                <div className="journey-target">
                    <h3><i className="fas fa-users"></i> تیم‌های هدف و مخاطبان</h3>
                    <div className="target-groups">
                        <span className="target-tag">دانشجویان و پژوهشگران </span>
                        <span className="target-tag">شرکت‌های فناور و استارت آپ‌ها</span>
                        <span className="target-tag">نهادهای دولتی و حاکمیتی </span>
                        <span className="target-tag">صنایع و سازمان‌ها</span>
                    </div>
                </div>
            </div>

        </section>
    )
}
export default Audience;